<script setup lang="ts">
import mitt from 'mitt'

const props = defineProps<{
  resourceId?: number
  resourceType?: ResourceType
}>()

const richTextRef = ref<RichTextRefIface>()
const emitter = mitt<RichTextEvent>()
const $toast = useToast()
const content = ref('')
const emit = defineEmits(['success', 'cancel'])
function cancel() {
  emit('cancel')
}
async function submit() {
  if (props.resourceId == undefined || props.resourceType == undefined) {
    $toast.error('没有找到资源')
    return
  }
  const length = richTextRef.value?.getContentLength()
  if (length && length > 200) {
    $toast.error('太多啦，动态内容不能超过200字哦亲')
    return
  }
  const res = await requestForwardFeed({
    resourceId: props.resourceId,
    resourceType: props.resourceType,
    content: content.value
  })
  if (res.code === 1) {
    $toast.success('转发成功')
    emit('success')
  } else {
    $toast.error(res.msg)
  }
}
</script>

<template>
  <div class="m-forward-form">
    <div class="m-forward-form__header">转发到动态</div>
    <RichText
      ref="richTextRef"
      v-model="content"
      :emitter="emitter"
      :max-length="200"
      mention
      class="editor"
      toolbar="#forward-content-toolbar"
      placeholder="请输入转发内容喵~"
      :formats="['sticker', 'mention', 'bold', 'italic', 'strike', 'underline']"
    />

    <RichTextToolBar
      id="forward-content-toolbar"
      class="m-forward-form__footer"
      :emitter="emitter"
      sticker
      mention
      bold
      italic
      strike
      underline
    >
      <n-button type="primary" size="small" @click="submit"> 发送 </n-button>
    </RichTextToolBar>
  </div>
</template>

<style lang="scss" scoped>
.m-forward-form {
  width: 100%;
  padding: 0 24px;
  background-color: #fff;
  border-radius: 8px;

  &__header {
    display: flex;
    pointer-events: none;
    font-size: 18px;
    margin-bottom: 12px;
  }
  &__footer {
    padding: 0 !important;
    margin-top: 12px;
  }
}
</style>
